import React from 'react';
import styles from './styles';
import {NavLink} from 'react-router-dom';
import {Button, StyledNavLink} from '@xpertdox_js/xdcomponents';
import NavItem from './NavItem';
import icons from './icons';
import {UserContext} from '../../Context/UserContext';
import instances from '../../config/instances';

const navLinkStyles = {
  styles: styles.subMenuItem,
  hoverStyles: styles.subMenuItemHov,
  activeStyles: {...styles.subMenuItem, ...styles.subMenuItemActive}
}

// --------- tabs component

const Tabs = props => {
  const {user, userAction} = React.useContext(UserContext);
  const userIsPI = user.accountType && user.accountType === 'PI';

  const buildNavLink = (itemObj, i) =>
    <StyledNavLink
      NavLink={NavLink}
      {...navLinkStyles}
      key={itemObj.title + i}
      to={{
        pathname: '/trial_list/' + props.instance + '/' + itemObj.trialTabID,
        state: {
          title: itemObj.title,
          auth: user,
          type: itemObj.fetchKey || props.trialTabID,
          instance: props.instance
        }
      }}
      text={itemObj.title}
    />
  ;

  let parsedItems = {
    ignored: [],
    trials: [],
    patients: [],
    users: [],
    survey: [],
    settings: [
      <StyledNavLink
        {...navLinkStyles}
        key={1}
        to={{
          pathname: '/' + props.instance + '/admin-actions',
          state: {
            auth: user,
            instance: props.instance
          }
        }}
        text='Admin Actions'
      />
    ],
    instances: [],
    feedback: [
      <StyledNavLink
        NavLink={NavLink}
        {...navLinkStyles}
        key='feedback_form'
        to={{
          pathname: '/' + props.instance + '/feedbackForm'
        }}
        text='Feedback & Bug Report'
      />,
    ]
  }
  props.navItems.forEach((itemObj,i) => {
      parsedItems[
        itemObj.trialTabID === 'xpertTriage'
        || itemObj.trialTabID === 'myPatients'
        || itemObj.trialTabID === 'triageStudies'
        || itemObj.trialTabID === 'triagePatients'
        || itemObj.trialTabID === 'triageSource'
        || itemObj.trialTabID === 'searchPatients'
        || itemObj.trialTabID === 'emailRecords'
        ? 'patients'
        // : (itemObj.trialTabID === 'searchPatients' || itemObj.trialTabID === 'emailRecords')
        // ? 'broadcast'
        : itemObj.trialTabID === 'surveyQuestions'
        ? 'ignored'
        : itemObj.trialTabID === 'userActivity'
        ? 'users'
        : 'trials'
      ].push(buildNavLink(itemObj, i));
  })
  // INSTANCE ADD
  if (user.isXDAdmin) {
    instances.forEach(instanceID => {
      parsedItems.instances.push(
        <Button
          key={instanceID}
          onClick={props.setInstance}
          clickParam={instanceID}
          styles={props.instance && props.instance === instanceID
            ? {...navLinkStyles.styles, ...navLinkStyles.activeStyles}
            : navLinkStyles.styles
          }
          hoverStyles={navLinkStyles.hoverStyles}
        >
          {instanceID}
        </Button>
      )
    })
  }
  // PI Tabs
  if (user.accountType === 'PI') parsedItems.trials.push(
    <StyledNavLink
      NavLink={NavLink}
      {...navLinkStyles}
      key='admin_message'
      to={{
        pathname: '/' + props.instance + '/admin_message'
      }}
      text='Remove or Add Trials'
    />
  );

  React.useEffect(() => {
    if (!props.subMenuContent) props.setSubMenuContent(parsedItems)
  }, [props.subMenuContent])


  return(
    <nav style={styles.navMenu}>
      <div style={styles.topIcons}>
        <NavItem
          items={parsedItems.user}
          title='Home'
          type='user'
          icon={icons.home}
          location='top'
          to={{pathname: `/${props.instance}`}}
        />
        {parsedItems.patients.length > 0 && <NavItem
          items={parsedItems.patients}
          title='Patients'
          type='patients'
          icon={icons.patients}
          location='top'
          to={{
            pathname: `/trial_list/${props.instance}/${userIsPI ? 'myPatients' : 'xpertTriage'}/`,
            state: {title: userIsPI ? 'My Patients' : 'Patient Triage'}
          }}
        />}
        <NavItem
          items={parsedItems.trials}
          title='Trials'
          type='trials'
          icon={icons.trials}
          location='top'
          to={{
            pathname: `/trial_list/${props.instance}/${userIsPI ? 'getTrials' : 'allTrials'}/`,
            state: {title: userIsPI ? 'My Trials' : 'Trials'}
          }}
        />
        {/* restrict tabs below to admin access only */
        (!user.accountType || user.accountType !== 'PI') &&
          <React.Fragment>
            <NavItem
              title='Survey'
              type='survey_questions'
              icon={icons.surveyQuestions}
              location='top'
              to={{pathname: `/trial_list/${props.instance}/surveyQuestions/`, state: {title: 'Survey Questions'}}}
            />
            <NavItem
              title='Users'
              type='users'
              icon={icons.patients}
              location='top'
              items={parsedItems.users}
              to={{
                pathname: '/trial_list/' + props.instance + '/userActivity',
                state: {
                    title: 'User Activity',
                    auth: user
                }
              }}
            />
          </React.Fragment>
        }
        {
        //   parsedItems.broadcast.length > 0 && <NavItem
        //   items={parsedItems.broadcast}
        //   title='Email Broadcast'
        //   type='broadcast'
        //   icon={icons.broadcast}
        //   location='top'
        // />
        }
      </div>
      <div style={styles.bottomIcons}>
        {parsedItems.instances.length > 0 &&
          <NavItem
          items={parsedItems.instances}
          title='Instances'
          type='instances'
          icon={icons.apps}
          location='bottom'
          to={{
            pathname: '/' + props.instance + '/instances',
            state: {
              title: 'Change Instance'
            }
          }}
        />}
        {parsedItems.feedback.length > 0 && <NavItem
          title='Feedback'
          type='feedback'
          icon={icons.feedback}
          location='bottom'
          to={{
            pathname: '/' + props.instance + '/feedbackForm',
            state: {
              title: 'Feedback & Bug Report'
            }
          }}
        />}
        {user.isXDAdmin && <NavItem
          items={parsedItems.settings}
          icon={icons.settings}
          title='Settings'
          type='admin'
          location='bottom'
          to={{
            pathname: '/' + props.instance + '/settings',
            state: {
              title: 'Settings'
            }
          }}
        />}
      </div>
    </nav>
  );
}

export default Tabs;
